import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ArrowImg from "../../../src/assets/img/left-angle.png";
import SlickImg1 from "../../../src/assets/img/slick-img-1.png";
import SlickImg2 from "../../../src/assets/img/slick-img-2.png";
import SlickImg3 from "../../../src/assets/img/slick-img-3.png";
import ImageContainer from "../../../src/assets/img/swiper-slider-item-back.png";
import HeadingImg from "../../../src/assets/img/title-left.png";

const Items = [
  {
    image: SlickImg1,
    title: "Concept of minimal donations",
    description: "Develop your character in game way, not for real money",
  },
  {
    image: SlickImg2,
    title: "Server with stage development",
    description:
      "In stages introduction of content and increasing the maximum level of item modification, harmoniously integrated into the concept.",
  },
  {
    image: SlickImg3,
    title: "Latest updates",
    description: " ⚡ We’re always updating! Our team is committed to delivering fresh content, balancing gameplay, and improving your experience.Expect regular patches, seasonal events, and exciting new features.",
  },
];

const Section2 = () => {
  const sliderRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Arrow components with responsive sizing
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <Box
        onClick={onClick}
        sx={{
          position: "absolute",
          top: "50%",
          right: { xs: "-25px", sm: "-30px", md: "-40px", lg: "-50px" },
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 1,
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-50%) scale(1.2)",
            filter: "brightness(1.3)",
          },
        }}
      >
        <img
          src={ArrowImg}
          alt="Next"
          style={{
            width: isMobile ? "40px" : isTablet ? "50px" : "70px",
            height: isMobile ? "40px" : isTablet ? "50px" : "70px",
            transform: "rotate(180deg)",
          }}
        />
      </Box>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <Box
        onClick={onClick}
        sx={{
          position: "absolute",
          top: "50%",
          left: { xs: "-25px", sm: "-30px", md: "-40px", lg: "-50px" },
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 1,
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-50%) scale(1.2)",
            filter: "brightness(1.3)",
          },
        }}
      >
        <img
          src={ArrowImg}
          alt="Previous"
          style={{
            width: isMobile ? "40px" : isTablet ? "50px" : "70px",
            height: isMobile ? "40px" : isTablet ? "50px" : "70px",
          }}
        />
      </Box>
    );
  };

  const settings = {
    dots: false,
    className: "center",
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    focusOnSelect: true,
    arrows: !isMobile, // Hide arrows on mobile
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "30px",
          arrows: false,
        },
      },
    ],
  };

  return (
    <Container
      sx={{
        py: { xs: 4, sm: 6, md: 8 },
        textAlign: "center",
        width: "100%",
        maxWidth: { xs: "100%", sm: "540px", md: "720px", lg: "1400px" },
        position: "relative",
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          mb: 10,
        }}
      >
        <Box component="img" src={HeadingImg} alt="Test Online" />
        <Typography
          variant="h2"
          fontWeight="bold"
          sx={{
            letterSpacing: 8,
            fontSize: 65,
            lineHeight: "1em",
            backgroundImage:
              "-webkit-linear-gradient(90deg, #ffd786 0%, #a6753a 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          FEATURES
        </Typography>
        <Box component="img" src={HeadingImg} alt="Test Online" />
      </Box>

      <Box sx={{ position: "relative", px: { xs: 0, sm: 2, md: 3 } }}>
        <Slider ref={sliderRef} {...settings}>
          {Items.map((item, index) => (
            <Box
              key={index}
              className="slick-slide-custom"
              sx={{
                px: { xs: 1, sm: 2, md: 3 },
                transition: "transform 0.4s ease, z-index 0.4s ease",
                "&.slick-center": {
                  transform: "scale(1.08)",
                  zIndex: 1500,
                  bgcolor: "red",
                },
              }}
            >
              <Box
                sx={{
                  backgroundImage: `url(${ImageContainer})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  p: { xs: 3, sm: 5, md: 7 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  transition: "all 0.3s ease",
                  height: "100%",
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.title}
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography
                mt={2}
                sx={{
                  letterSpacing: 2,
                  fontSize: 25,
                  fontWeight: "bolder",
                  color: "#ffebad",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  letterSpacing: 0.5,
                  fontSize: 15,
                }}
              >
                {item.description}
              </Typography>
            </Box>
          ))}
        </Slider>
      </Box>
    </Container>
  );
};

export default Section2;
